import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { GridSizeChangedEvent } from 'ag-grid-community';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { BtnDeleteCellRenderer } from 'src/app/btn-deletecell-renderer';
import { MatCheckboxRendererComponent } from 'src/app/mat-checkbox-renderer';
import { MatSelectRendererComponent } from 'src/app/mat-selectlist-renderer';
import { KpitreeService } from 'src/app/services/kpitree.service';
import { MeetingEvaluationService } from 'src/app/services/meeting-evaluation.service';
import { UserManagementService } from 'src/app/services/usermanagement.service';
import { EmployeeService } from 'src/backend/services/user-access-services/employee.service';
import { ThemePalette } from '@angular/material/core';
import { NgxSpinnerService } from 'ngx-spinner';

import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MeetingMatrixService } from 'src/app/services/meeting-matrix.service';
import { CommonService } from 'src/app/services/common.service';
import { MatTableDataSource } from '@angular/material/table';
import { OverallActionPlanService } from 'src/app/services/overall-actionPlan.service';
import { TooltipModule } from 'primeng/tooltip';
import { param } from 'jquery';
import { DatePipe } from '@angular/common';
import { ImageDialogComponent } from 'src/app/analytical-tools/image-dialog/image-dialog.component';
import {
  differenceInCalendarDays,
  endOfMonth,
  startOfMonth,
  startOfYesterday,
} from 'date-fns';
import { DatepickerService } from 'src/app/services/Datepicker.service';
import { Constants } from 'src/@smartmanufacturing/common/constants';

@Component({
  selector: 'app-meeting-evaluation',
  templateUrl: './meeting-evaluation.component.html',
  styleUrls: ['./meeting-evaluation.component.scss']
})
export class MeetingEvaluationComponent implements OnInit {
  @ViewChild('actionPlanModal') private actionPlanModal!: TemplateRef<any>;
  @ViewChild('fileInput') fileInput!: ElementRef;
  @ViewChild('fileInputFile') fileInputFile!: ElementRef;
  gridApi: any;
  gridColumnApi: any;
  modules: any;
  defaultColDef: any;
  components: any;
  overallMeetingActions: any[]
  kpiName: string = '';
  userList: any = [];
  meetingEvaluationData!: MatTableDataSource<any>;
  GRDData = new MatTableDataSource();
  editActionPlanForm!: FormGroup;
  fileSave: any;
  closefile: any;
  disableForm: boolean = false;
  meetingStarted = false;
  addActionForm!: FormGroup;
  public color: ThemePalette = 'primary';
  columnDefsallAction: any
  participantsByPlants: any[];
  columnDefs: any;
  columnDefs1: any;
  rowData: any[] = [];
  bottomData: any;
  rowData1: any[] = [];
  MeetingEvaluationForm!: FormGroup;
  bottomOptions = {
    alignedGrids: [],
    defaultColDef: {
      flex: 1,
      minWidth: 110,
    }
  };
  gridOptions = {
    frameworkComponents: {
      btnCellRenderer: BtnDeleteCellRenderer,
      checkboxRenderer: MatCheckboxRendererComponent,
      slectlistRenderer: MatSelectRendererComponent
    },
  };
  @ViewChild('paginator', { static: true }) paginator!: MatPaginator;
  suggestedPaginator!: MatPaginator;
  meetingMasterId = 0;
  ownerList: any[] = [];
  rowSpanCount = 0;
  currentKPIId: any;
  addDisableVerification = true;
  totalWeight = 0;
  totalScore = 0;
  totalScorePercentage = '0';
  isSaving = false;
  disabled = true;
  successMessage = '';
  paramsValues: any = {
    plant: 0,
    meeting: 0,
    group: 0,
    meetingAttendId: 0,
    participantId: 0
  };
  isEvaluationFilled = false;
  targetDate: string | number | Date;
  headerId: any;
  shiftData: any[] = [];
  imageFile: any;
  imageSrc: string;
  data: any;
  Status: any;
  ImageSave: any;
  disableVerification: boolean;
  disableNewAssigne: boolean;
  doc: string;
  plants!: any;
  currentNodeDate: any;
  calendarPlantId: any;
  currentAssigneeEmail: any;
  currentResponsibleEmail: any;
  ModuleName: any;
  RevisedDate: any;
  UniqueCode: any;
  showinput: boolean;
  images: any[] = [];
  displayMaximizable: boolean;
  fileDesc: any;
  fileType: string;
  blobStorageUrl: string = Constants.BLOB_STORAGE_URL;
  filteredPlants!: any[];
  currentDialog: any;
  mClassificationTypes: any[] = [];
  firstDayOfWeek: any;
  constructor(private fb: FormBuilder, private toaster: ToastrService,
    private usermanagementService: UserManagementService,
    private meetingEvaluationService: MeetingEvaluationService,
    private route: ActivatedRoute, private kpiservice: KpitreeService,
    private meetingService: MeetingMatrixService,
    private commonService: CommonService,
    private datePipe: DatePipe,
    private datepickerService: DatepickerService,
    private spinner: NgxSpinnerService,
    private dialog: MatDialog,
    private actionplanService: OverallActionPlanService,
    private employeeService: EmployeeService,) {
    this.MeetingEvaluationForm = this.fb.group({
      meeting: [''],
      location: [''],
      leader: [''],
      date: ['']
    });
    this.addActionForm = this.fb.group({
      id: [''],
      action: ['', Validators.required],
      actionType: ['', Validators.required],
      assignTo: ['', Validators.required],
      targetDate: ['', Validators.required],
      mClassification: [''],
      kpi: [''],
    });
    this.columnDefsallAction = [
      {
        field: 'actions',
        headerName: 'Actions',
        width: 100,
        resizable: true,
        filter: true,
        cellRenderer: (params: any): any => {
          if (params.data.Status !== 'Closed') {
            return `
            <div>
            <button mat-mini-fab=""
            color="primary"
            ptooltip="Action Delete"
            title="Edit Action"
            tooltipposition="top"
            class="viewRCA mat-focus-indicator mat-mini-fab mat-button-base mat-primary" ng-reflect-color="primary"><span class="mat-button-wrapper"><mat-icon role="img" class="mat-icon notranslate material-icons mat-icon-no-color" aria-hidden="true" data-mat-icon-type="font">edit</mat-icon></span><span matripple="" class="mat-ripple mat-button-ripple mat-button-ripple-round" ng-reflect-disabled="false" ng-reflect-centered="false" ng-reflect-trigger="[object HTMLButtonElement]"></span><span class="mat-button-focus-overlay"></span></button>
             </div>
          `;
          }
        },
      },
      {
        field: 'RootCause',
        headerName: 'Root Cause',
        resizable: true,
        filter: true,
      },
      {
        field: 'Action',
        headerName: 'Meeting Action',
        resizable: true,
        filter: true,
        width: 150,
      },
      {
        field: 'KPIName',
        headerName: 'KPI Name',
        resizable: true,
        filter: true,
      },
      {
        field: 'Status',
        headerName: 'Status',
        resizable: true,
        filter: true,
        width: 100,
        cellStyle: function (params: any): any {
          if (params.value == 'Open')
            return { color: 'white', backgroundColor: 'gray' };
          else if (params.value == 'InProgress')
            return { color: 'white', backgroundColor: 'orange' };
          else if (params.value == 'Complete')
            return { color: 'white', backgroundColor: '#1cd51c' };
          else if (params.value == 'Closed')
            return { color: 'white', backgroundColor: 'green' };
          else if (params.value == 'Delayed')
            return { color: 'white', backgroundColor: 'brown' };
          else if (params.value == 'Rejected')
            return { color: 'white', backgroundColor: 'red' };
        },
      },
      {
        field: 'AssignedDate',
        headerName: 'Assigned Date',
        resizable: true,
        filter: true,
        valueFormatter: function (params) {
          return params.value
            ? moment(params.value).format('MMMM d, YYYY')
            : params.value;
        },
        width: 150,
      },
      {
        field: 'AssingedBy',
        headerName: 'Assigned By',
        resizable: true,
        width: 150,
        filter: true,
      },
      {
        field: 'TargetDate',
        headerName: 'Target Date',
        resizable: true,
        filter: true,
        valueFormatter: function (params) {
          return params.value
            ? moment(params.value).format('MMMM d, YYYY')
            : params.value;
        },
        width: 150,
      },
      {
        field: 'NoOfMisses',
        headerName: 'No of Misses',
        resizable: true,
        filter: true,
      },
      {
        field: 'RevisedDate',
        headerName: 'New Target Date',
        resizable: true,
        filter: true,
        valueFormatter: function (params) {
          return params.value
            ? moment(params.value).format('MMMM d, YYYY')
            : params.value;
        },
        width: 150,
      },
      {
        field: 'ActionCompleted',
        headerName: 'Completed',
        filter: true,
        resizable: true,
        width: 130,
      },
      {
        field: 'ClosedFile',
        headerName: 'Closed File',
        sortable: true,
        resizable: true,
        filter: true,
        cellRenderer: function (params: any) {
          let html = '';
          if (params && params.value) {
            html = `<button mat-mini-fab=""
             color="primary"
             ptooltip="View document"
             title="View document"
             tooltipposition="top"
             class="viewDocument mat-focus-indicator mat-mini-fab mat-button-base mat-primary" ng-reflect-color="primary"><span class="mat-button-wrapper"><mat-icon role="img" class="viewDocument mat-icon notranslate material-icons mat-icon-no-color" aria-hidden="true" data-mat-icon-type="font">visibility</mat-icon></span><span matripple="" class="viewDocument mat-ripple mat-button-ripple mat-button-ripple-round" ng-reflect-disabled="false" ng-reflect-centered="false" ng-reflect-trigger="[object HTMLButtonElement]"></span><span class="mat-button-focus-overlay"></span></button>
            `;
          }
          return html;
        },
      },
      {
        field: 'Remarks',
        headerName: 'Remarks',
        resizable: true,
        filter: true,
      },
    ];
    this.columnDefs = [
      {
        field: 'area',
        wrapText: true,
        resizable: true,
        cellRenderer: (params: any) => {
          if (params.value && params.value.name) {
            return '<div class="area-name">' +
              params.value.name +
              '' +
              '</div>';
          } else { return ''; }
        },
        rowSpan: this.rowSpan,
        cellClassRules: { 'show-cell': 'value !== undefined' },
        cellStyle: (params: any) => {
          if (params.value && params.value.name) {
            return { background: '#49FFB9', border: '1px solid #333' };
          } else {
            return { background: '#49FFB9' };
          }
        },
        width: 120,
      },
      { field: 'detail', headerName: 'check detail', width: '390' },
      { field: 'weight', headerName: 'Weight', width: '150' },
      {
        field: 'score', headerName: 'Self Evaluation Score', width: '200', editable: true,
        onCellValueChanged: (params: any) => this.onChangeScore(params),
        cellRenderer: 'agCellRenderer',
        cellEditor: 'agRichSelectCellEditor',
        cellEditorParams: {
          cellRenderer: 'genderCellRenderer',
          values: ['0', '0.5', '1'],
        },
        cellStyle: {
          color: 'black',
          'background-color': '#EDF1E5',
        }
      }
    ];
    this.editActionPlanForm = this.fb.group({
      id: [''],
      remarks: [''],
      closefile: [''],
      revisedDate: [''],
      actions: [''],
      assignTo: [''],
      completed: ['No'],
      verification: [''],
      actionType: [''],
      targetDate: [''],
      NewAssignee: [''],
      rootcause: [''],
      mClassification: [''],
    });
  }
  ngOnInit(): void {
    this.route.queryParams.subscribe(param => {
      this.paramsValues.plant = param?.plant ? (param?.plant) : 0;
      this.paramsValues.meeting = param?.meeting ? parseInt(param?.meeting, 10) : 0;
      this.paramsValues.group = param?.group ? (param?.group) : 0;
      this.paramsValues.meetingAttendId = param?.meetingAttendId ? parseInt(param?.meetingAttendId, 10) : 0;
      this.paramsValues.participantId = param?.participantId ? (param?.participantId) : 0;
    });
    this.getUsers();
    this.getMeetingDefinations();
    this.getParticipantsOnPlant();
    this.getOverallMeetingActions();
    this.getPlantByGroup();
    this.getMClassificationList();
  }

  selectedMeeting: any = {
    meetingId: 0,
    meetingName: '',
    meetingType: '',
  };
  openActionPlan(params: any) {
    this.editActionPlanForm.patchValue(params.data);
    const dialogRef = this.dialog.open(this.actionPlanModal, {
      data: {
        params,
      },
    });

    dialogRef.afterClosed().subscribe((data) => {
      this.getOverallMeetingActions();
    });
  }

  getMClassificationList() {
    this.actionplanService.getMClassification().subscribe(
      (response) => {
        this.mClassificationTypes = response;
      },
      (error) => {
        this.toaster.error('Error', 'Something Went Wrong');
      }
    );
  }

  // getUserList(): void {
  //   this.employeeService.getAllEmployees().subscribe(
  //     (res: any) => {
  //       this.UserDDL = res;
  //       this.filteredParticipants = this.UserDDL.slice();
  //       this.filteredUsers = this.UserDDL.slice();
  //       this.filterBanksMulti();
  //     },
  //     (err: any) => {
  //       this.spinner.hide();
  //     }
  //   );

  onCellEditingStarted(params: any) {
    setTimeout(() => {
      const popup = document.querySelector('.ag-popup-editor') as HTMLElement;
      const rowIndex = params.node.rowIndex;
      const totalRows = this.gridApi.getDisplayedRowCount();

      if (popup && rowIndex >= totalRows - 2) {
        const currentTop = parseInt(window.getComputedStyle(popup).top, 10);

        if (!isNaN(currentTop)) {
          const newTop = currentTop - 110;
          popup.style.setProperty('top', `${newTop}px`, 'important'); // Apply forced change
        }
      }
    }, 0);
  }

  getUsers(): void {

    // const key = {
    //   EGId: this.paramsValues.group,
    //   PlantId: this.paramsValues.plant
    // };
    // this.kpiservice.getEmployeeMasterData(key).then((data) => {
    this.employeeService.getAllEmployees().subscribe(
      (data: any) => {
        // this.ownerList = data ;
        //  this.UserDDL = res;
        // console.log(data);
        this.ownerList = data?.map((user: any) => {
          return {
            id: user.employeeCode,
            name: user.fullName
          };
        });
        this.columnDefs1 = [
          { field: 'problem', headerName: 'Problem', width: 250, editable: true },
          { field: 'action', headerName: 'Action Required', width: 300, editable: true },
          {
            field: 'owner', headerName: 'Owner', width: 215, editable: true,
            cellRenderer: 'slectlistRenderer',
            cellEditorParams: {
              data: this.ownerList
            },
          },
          {
            field: 'date', headerName: 'Date', width: 150,
            valueFormatter: (prop: any) => moment(new Date().toISOString()).format('DD-MM-YYYY')
          },
          {
            field: 'successful', headerName: 'Successful ?', width: 150,
            cellRenderer: 'checkboxRenderer'
          },
          {
            field: 'rowId', headerName: 'Action', width: 150,
            cellRenderer: 'btnCellRenderer',
            cellRendererParams: {
              onClick: this.deleteRow.bind(this),
              label: 'Delete',
            }
          },
        ];
        this.rowData1 = [
          {
            problem: '', action: '', owner: this.ownerList[0].id,
            date: moment(new Date().toISOString()).format('DD-MM-YYYY'), successful: false, rowId: Math.floor(Math.random() * 1000),
            IsWrite: true
          }
        ];
      }, ({ error }) => {
        this.toaster.error(error.message);
      });
  }

  getMeetingDefinations(): void {

    const key = {
      plantId: this.paramsValues.plant,
      meetingId: this.paramsValues.meeting,
      meetingAttendId: this.paramsValues.meetingAttendId,
      participantId: this.paramsValues.participantId
    };
    this.meetingEvaluationService.getAllMeetingEvaluationActions(key).subscribe(res => {
      this.meetingMasterId = res?.meetingMasterId;
      //  setting values in form group
      this.MeetingEvaluationForm.get('meeting')?.setValue(res?.meetingDefName);
      this.MeetingEvaluationForm.get('leader')?.setValue(res?.leaderName);
      this.MeetingEvaluationForm.get('date')?.setValue(new Date());
      this.isEvaluationFilled = res?.isEvaluation;

      //Write this To disbale Meeting Evaluation Form When User Already orSave Record One time    -- Code Start
      if (this.isEvaluationFilled) {
        this.disableForm = true;
      }

      //Write this To disbale Meeting Evaluation Form When User Already orSave Record One time    -- Code End


      // getting thte unique areas from response
      const uniqueAreas = [... new Set(res?.detail?.map((item: any) => {
        return item.name;
      }))];
      // setting the total weight
      this.totalWeight = res?.detail.map((item: any) => {
        return item?.weight;
      }).reduce((a: any, b: any) => a + b);
      // setting the total score
      this.totalScore = res?.detail.map((item: any) => {
        return parseFloat(item?.score);
      }).reduce((a: any, b: any) => a + b);
      // setting the total score percentage
      this.totalScorePercentage = ((this.totalScore / res?.detail.length) * 100).toFixed(2);

      // formate data according to the ag grid
      const formattedArray: any[] = [];
      uniqueAreas.forEach(area => {
        const filteredArray = res?.detail.filter((x: any) => x?.name === area);
        if (filteredArray.length > 0) {
          filteredArray.forEach((meeting: any) => {
            const areafound = formattedArray.findIndex((item: any) => {
              return item?.area?.name === area;
            });
            if (areafound === -1) {
              formattedArray.push({
                area: {
                  name: area
                },
                detail: meeting?.detail,
                weight: meeting?.weight,
                score: meeting?.score,
                totalcount: filteredArray?.length
              });
            } else {
              formattedArray.push({
                detail: meeting?.detail,
                weight: meeting?.weight,
                score: meeting?.score
              });
            }
          });
        }
      });
      // setting formatted data in ag grid
      this.rowData = formattedArray;
    }, ({ error }) => {
      this.toaster.error(error.message);
    });
  }


  targetChange(): void {
  }


  onChangeComplete(): void {
    if (this.editActionPlanForm.value.completed === 'Yes') {
      this.addDisableVerification = false;
      this.disableVerification = false;
      this.editActionPlanForm.get('verification').setValue('');
    }
    else {
      this.addDisableVerification = true;
      this.disableVerification = true;
      this.editActionPlanForm.get('verification').setValue('');
    }
  }

  onChangeVerification(): void {
    if (this.editActionPlanForm.value.verification === 'Disapproved') {
      this.disableNewAssigne = false;
    } else if (this.editActionPlanForm.value.verification !== 'Disapproved') {
      this.disableNewAssigne = true;
    }
    if (this.editActionPlanForm.value.verification === 'Approved') {
      this.showinput = true;
    } else {
      this.showinput = false;
    }
  }

  onChangeScore(params: any): void {
    // setting the total score
    this.totalScore = this.rowData.map((item: any) => {
      return parseFloat(item?.score === '1' ? item.weight : item?.score === '0.5' ? (item.weight / 2) : 0);
    }).reduce((a: any, b: any) => a + b);
    // setting the total score percentage
    this.totalScorePercentage = ((this.totalScore / this.totalWeight) * 100).toFixed(2);
  }

  saveRecord(): void {
    this.isSaving = true;
    const data = {
      meetingMasterId: this.meetingMasterId,
      date: this.MeetingEvaluationForm.value.date,
      meetingAttendId: this.paramsValues.meetingAttendId,
      participantId: this.paramsValues.participantId,
      details: this.rowData?.map((item) => {
        return {
          selfEvaScore: parseFloat(item?.score),
          weight: item?.weight,
          percentage: parseFloat(this.totalScorePercentage),
        };
      }),
      actions: this.rowData1?.filter(x => x.problem !== '').map((item) => {
        return {
          problem: item?.problem,
          actionRequired: item?.action,
          ownerId: item?.owner,
          date: new Date(item?.date),
          isSuccess: item?.successful,
          IsWrite: true
        };
      })
    };
    // if (data.actions.length > 0) {
    this.meetingEvaluationService.addMeetingEvaluation(data).subscribe(res => {
      this.successMessage = 'Thanks for your feedback';
      this.getUsers();
      this.getMeetingDefinations();
      this.isSaving = false;
    }, ({ error }) => {
      this.toaster.error(error.message);
      this.isSaving = false;
    });
    // } else {
    //   this.toaster.warning('Please add some actions first');
    //   this.isSaving = false;
    // }
  }

  addNewRow(): any {
    if (this.rowData1.filter(x => x.problem === '' || x.action === '')?.length > 0) {
      this.toaster.warning('Please Fill Or Remove Empty fields first');
      return;
    }
    const slicedRowData = this.rowData1.slice();
    slicedRowData.push({
      problem: '',
      action: '',
      owner: this.ownerList[0].id,
      date: moment(new Date().toISOString()).format('DD-MM-YYYY'),
      successful: false,
      rowId: Math.floor(Math.random() * 1000),
      IsWrite: true
    });
    this.rowData1 = slicedRowData;
  }

  deleteRow(e: any): any {
    this.rowData1 = this.rowData1.filter(x => x.rowId !== e.rowData?.rowId);
  }
  rowSpan(params: any): any {
    if (params.data.area) {
      return params.data.totalcount;
    } else {
      return 1;
    }
  }
  onGridReady(params: any): any {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.setDomLayout('autoHeight');

    const element: HTMLElement = document.querySelector('#agGrid') as HTMLElement;
    if (element !== null) {
      element.style.height = '';
    }
  }
  onGridSizeChanged(params: GridSizeChangedEvent): any {
    params.api.sizeColumnsToFit();
  }
  getOverallMeetingActions() {
    const data = {
      meetingId: this.paramsValues.meeting,
    };
    this.meetingService.getAllMeetingActions(data).subscribe(
      (response) => {
        this.rowData1 = response;
        this.overallMeetingActions = response;
        //this.createLineAndStackChart(response);
      },
      (err: any) => {

      }
    );
  }
  getParticipantsOnPlant() {

    let data = {
      groupCode: this.paramsValues.group,
      plantCode: this.paramsValues.plant,
    };

    this.employeeService.getAllEmployees().subscribe(
      (response: any) => {
        if (!response.HasError) {
          // this.orgMachineryList.map((machinery: any) => this.machineryList.push([...this.mList.machineryList]));
          this.participantsByPlants = response;
          // this.participantsByPlants.map(
          //   (user: any) =>
          //   (user.FullName =
          //     user.FirstName.trim() + ' ' + user.lastName.trim())
          // );
          this.userList = this.participantsByPlants.slice();
        }
      },
      (err: any) => {

      }
    );
  }
  addActionPlan(): void {
    let status =
      this.addActionForm.value.targetDate &&
        !this.addActionForm.value.revisedDate
        ? 'InProgress'
        : this.addActionForm.value.targetDate &&
          this.addActionForm.value.revisedDate
          ? 'Delayed'
          : 'Open';
    if (this.addActionForm.value.verification === 'Approved') {
      status = 'Closed';
      // fiveWhy.ClosedDate = new Date();
    } else if (this.addActionForm.value.verification === 'Disapproved') {
      status = 'ReOpened';
      // fiveWhy.ActionCompleted = 'No';
      this.addActionForm.get('completed').setValue('No');
    }
    this.targetDate = this.addActionForm.value.targetDate;
    this.targetDate = new Date(this.targetDate);
    this.targetDate.setHours(new Date().getHours());
    this.targetDate.setMinutes(new Date().getMinutes());
    this.targetDate.setSeconds(new Date().getSeconds());

    const key = {
      actionName: this.addActionForm.value.action,
      actionType: this.addActionForm.value.actionType,
      responsible: this.addActionForm.value.assignTo,
      PriorityLevel: 1,
      targetDate: this.targetDate,
      status: status,
      userCode: this.paramsValues.participantId,
      // userCode: JSON.parse(localStorage.user).UserId,
      plantCode: this.paramsValues.plant,
      // meetingStatus: this.meetingStarted === true ? 1 : 0,
      // meetingId: this.selectedMeeting.meetingId ,
      // kpiId: this.currentKPIId
      mClassification: this.addActionForm.value?.mClassification,
      meetingStatus: 1,
      meetingId: this.paramsValues.meeting,
      kpiId: 0
    };
    this.spinner.show();
    this.actionplanService.addActionPlan(key).subscribe(({
      next: (res: any) => {
        this.spinner.hide();
        if (res?.data[0]?.message === 'Add Successfully') {
          this.toaster.success('Sucess', 'Added Successfully');
          this.getOverallMeetingActions();
          this.addActionForm.reset();
          this.addActionForm.get('actionType')?.setValue('Corrective');
          this.addActionForm.get('kpi')?.setValue(this.kpiName);
        }
      },
      error: ({ error }) => {
        this.spinner.hide();
        this.toaster.error('Error', '');
      }
    }));
  }

  readFile(event: any, type: any): void {
    this.imageFile = event.target.files[0];
    if (type === 'pic') {
      this.data.UploadFile = this.imageFile;
      this.ImageSave = event.target.files[0];
    } else {
      this.data.UploadDoc = this.imageFile;
      this.fileSave = event.target.files[0];
    }
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.imageSrc = reader.result as string;
        if (type === 'pic') {
          this.data.FileSrc = this.imageSrc;
        } else {
          this.data.DocSrc = this.imageSrc;
        }
      };
    }
  }

  cellClickedActionTable(params: any) {
    let col = params.colDef.field;

    let classList = params.event.target.classList;
    if (col === 'actions') {
      if (
        classList.contains('mat-icon-no-color') ||
        classList.contains('viewRCA')
      ) {
        this.EditRow(params);
      }
    }
    if (col === 'ClosedFile') {
      if (classList.contains('viewDocument')) {
        this.doc =
          this.blobStorageUrl +
          params.data.ClosedFile;
        const fileType = params.data.ClosedFile.split('.').pop();
        if (
          fileType === 'jpeg' ||
          fileType === 'jpg' ||
          fileType === 'png' ||
          fileType === 'gif'
        ) {
          this.images = [];
          this.fileType = 'img';
          this.images.push(this.doc);
        } else {
          this.fileType = 'doc';
        }
        this.fileDesc = params.data?.KPIName;
        this.displayMaximizable = true;
      }
    }
  }

  EditRow(params: any): void {
    this.headerId = params?.data?.HeaderId;
    if (params) {
      this.data = [];
      this.ImageSave = null;
      this.fileSave = null;
      this.closefile = null;
      this.currentNodeDate = params.node.data.ObservedDate;
      this.currentAssigneeEmail = params.node.data.AssigneEmail;
      this.currentResponsibleEmail = params.node.data.ParticpantEmails;
      this.data = params.node.data;
      this.ModuleName = params.node.data.Module;
      this.UniqueCode = params.node.data.UniqueCode;
      this.editActionPlanForm.get('actions').setValue(params.node.data.Action);
      this.editActionPlanForm.get('rootcause').setValue(params.node.data.RootCause);
      this.editActionPlanForm
        .get('assignTo')
        .setValue(params.node.data.AssignTo);
      this.editActionPlanForm
        .get('completed')
        .setValue(params.node.data.ActionCompleted);
      this.editActionPlanForm.get('remarks').setValue(params.node.data.Remarks);
      this.editActionPlanForm.get('remarks').setValue(params.node.data.Remarks);
      this.editActionPlanForm.get('mClassification').setValue(params.node.data.M_Classification);
      this.editActionPlanForm
        .get('NewAssignee')
        .setValue(params.node.data.NewAssigneeId);
      if (params.node.data.ActionCompleted === 'No') {
        this.disableVerification = true;
      }
      if (params.node.data.Verification === 'Disapproved') {
        this.disableNewAssigne = false;
      }
      this.editActionPlanForm
        .get('verification')
        .setValue(params.node.data.Verification);
      this.editActionPlanForm
        .get('actionType')
        .setValue(params.node.data.ActionType);
      if (params.node.data.RevisedDate !== null) {
        this.editActionPlanForm
          .get('revisedDate')
          .setValue(
            this.datePipe.transform(
              new Date(params.node.data.RevisedDate),
              'yyyy-MM-dd'
            )
          );
      }
      if (params.node.data.TargetDate !== null) {
        this.editActionPlanForm
          .get('targetDate')
          .setValue(
            this.datePipe.transform(
              new Date(params.node.data.TargetDate),
              'yyyy-MM-dd'
            )
          );
      }
      this.targetDate = params.node.data.TargetDate;

      if (params.data.UploadFile) {
        this.data.UploadFile = params.data.UploadFile;
      }
      // this.editActionPlanForm.get('targetDate').setValue(params.data.TargetDate) ;
      this.currentDialog = this.dialog.open(this.actionPlanModal, { height: 'auto', width: '90%' });
    }
  }

  imageZoomModal(): void {
    let dialogRef = this.dialog.open(ImageDialogComponent, {
      height: '90%',
      width: '90%',
      data:
        this.data.FileSrc || Constants.BLOB_STORAGE_URL + this.data.UploadFile,
    });
    // this.dialog.open(this.imageZoomModel, { height: '90%', width: '90%' });
  }

  openFile(type?: any): void {
    if (type === 'pic') {
      this.fileInput.nativeElement.click();
    } else {
      this.fileInputFile.nativeElement.click();
    }
  }

  deleteFile(type: any): void {
    if (type === 'pic') {
      this.data.FileSrc = '';
      this.data.UploadFile = '';
      this.ImageSave = new File([''], 'filename');
    } else {
      this.data.DocSrc = '';
      this.data.UploadDoc = '';
      this.fileSave = new File([''], 'filename');
    }
  }
  downloadPDF() {
    // [href]=" yData.DocSrc || blobStorageUrl + yData.UploadDoc"
    if (this.data.DocSrc) {
      const base64 = this.data.DocSrc;
      var a = document.createElement('a'); //Create <a>
      a.href = base64; //Image Base64 Goes here
      a.target = '_blank';
      a.download = 'file.pdf'; //File name Here
      a.click();
    } else {
      var a = document.createElement('a'); //Create <a>
      a.href = this.blobStorageUrl + this.data.UploadDoc; //Image Base64 Goes here
      a.download = 'file.pdf';
      a.target = '_blank'; //File name Here
      a.click();
    }
  }
  uploadedFile(event: any): void {
    if (event.target.files.length > 0) {
      this.closefile = event.target.files[0];
    }
  }
  getPlantByGroup(): void {
    const key = {
      groupCode: this.paramsValues.group,
    };
    this.meetingService.getPlantsDataByGroup(key).subscribe(
      (data: any) => {
        this.plants = data.filter((p: any) => p.PlantName);
        this.filteredPlants = this.plants.slice();
        this.getFrequencyOnMeeting();
        this.getMasterShift();

        // this.GetTierMeetingChecklist_Data();
        this.calendarPlantId = this.paramsValues.plant;
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }
  setFirstWeek(): void {
    const dept = this.plants.find(item => item.PlantCode === this.paramsValues.plant);
    this.firstDayOfWeek = dept ? dept.firstDayOfWeek : 0;
    this.setWeekValue(this.firstDayOfWeek);
  }
  getFrequencyOnMeeting(): void {
    this.calendarPlantId = this.paramsValues.plant;
    this.setFirstWeek();
  }
  setWeekValue(weekDay: number): void {
    if (weekDay == undefined || weekDay == null || Number.isNaN(weekDay))
      weekDay = 0
    sessionStorage.removeItem('weekDay');
    sessionStorage.setItem('weekDay', weekDay.toString());
    this.datepickerService.getFirstDayOfWeek()
  }
  getMasterShift(): void {
    const key = {
      plantCode: this.paramsValues.plant,
    };
    this.meetingService.getMasterShifts(key).subscribe(
      (data) => {
        this.shiftData = data;
        // this.shiftData.forEach((c=>))
        this.shiftData.forEach((element) => {
          element.startTime = new Date().setTime(element.startTime);
          element.endTime = new Date().setTime(element.endTime);
        });
      },
      (error: any) => {
        this.toaster.error('Error', error.error.message);
      }
    );
  }
  UpdateActionPlan(): void {
    this.Status = '';
    this.Status =
      this.editActionPlanForm.value.targetDate &&
        !this.editActionPlanForm.value.revisedDate
        ? 'InProgress'
        : this.editActionPlanForm.value.targetDate &&
          this.editActionPlanForm.value.revisedDate
          ? 'Delayed'
          : 'Open';

    if (this.editActionPlanForm.value.targetDate) {
      this.targetDate = this.editActionPlanForm.value.targetDate;
      this.targetDate = new Date(this.targetDate);
      this.targetDate.setHours(new Date().getHours());
      this.targetDate.setMinutes(new Date().getMinutes());
      this.targetDate.setSeconds(new Date().getSeconds());
    }
    if (this.editActionPlanForm.value.revisedDate) {
      this.RevisedDate = this.editActionPlanForm.value.revisedDate;
      this.RevisedDate = new Date(this.RevisedDate);
      this.RevisedDate.setHours(new Date().getHours());
      this.RevisedDate.setMinutes(new Date().getMinutes());
      this.RevisedDate.setSeconds(new Date().getSeconds());
    }
    if (this.editActionPlanForm.value.completed === 'Yes') {
      this.Status = 'Complete';
      var templateBody = null;
      var plantName = null;

      var plant = this.plants.find(
        // (x) => x.DeptId == this.MeetingMatrixForm.value.plant
        (x) => x.PlantCode == this.paramsValues.plant
      );
      plantName = plant.PlantName;
      var date = null;
      var user = this.userList.find(
        (x) => x.employeeCode == this.editActionPlanForm.value.assignTo
      );
      if (
        this.editActionPlanForm.controls.revisedDate.value >
        this.editActionPlanForm.controls.targetDate.value
      ) {
        date = this.editActionPlanForm.controls.revisedDate.value;
      } else {
        date = this.editActionPlanForm.controls.targetDate.value;
      }
      if (this.editActionPlanForm.controls.verification.value == 'Approved') {
        templateBody =
          `<div style="font-family: Helvetica; display: flex; flex-direction: column;">
        <div style="display: flex;background-color:#1d4ed8; color: white; padding: 2rem">
            <h2 style="margin-right: auto">O3 SMART MANUFACTURING</h2>
            <img src="https://res.cloudinary.com/durdmvneg/image/upload/v1629181792/logo-full_ku1lp4.png" style="display: block; border: 0px; object-fit:contain ;" />
        </div>
        <h2 style="margin-left: auto; margin-right: auto; margin-top: 1rem; font-weight: 800">Action Plan Detail</h2>
        <div style="background-color: #f3f4f6; padding: 1rem; display: flex;">
            <div style="width: 20%;font-weight: 800;">Plant: </div><div style="width: 80%;font-weight: 800;">` +
          plantName +
          `</div>
        </div>
        <table style="margin-top: 1.5rem;">
            <tr>
                <th style="background-color:#e7e5e4; padding: 0.8rem">Action Plan</th>
                <th style="background-color:#e7e5e4; padding: 0.8rem">Created Date</th>
                <th style="background-color:#e7e5e4; padding: 0.8rem">Target Date</th>
                <th style="background-color:#e7e5e4; padding: 0.8rem">Responsible</th>
                <th style="background-color:#e7e5e4; padding: 0.8rem">Status</th>
            </tr>
            <tr>
                <td style='text-align: center'>` +
          this.editActionPlanForm.controls.actions.value +
          `</td>
                <td style='text-align: center'>` +
          moment(this.currentNodeDate).format('DD/MM/YYYY hh:mm:ss') +
          `</td>
                <td style='text-align: center'>` +
          moment(date).format('DD/MM/YYYY hh:mm:ss') +
          `</td>
                <td style='text-align: center'>` +
          user.FullName +
          `</td>
                <td style='text-align: center'>Closed</td>
            </tr>
        </table>
    </div>`;
      } else {
        templateBody =
          `<div style="font-family: Helvetica; display: flex; flex-direction: column;">
        <div style="display: flex;background-color:#1d4ed8; color: white; padding: 2rem">
            <h2 style="margin-right: auto">O3 SMART MANUFACTURING</h2>
            <img src="https://res.cloudinary.com/durdmvneg/image/upload/v1629181792/logo-full_ku1lp4.png" style="display: block; border: 0px; object-fit:contain ;" />
        </div>
        <h2 style="margin-left: auto; margin-right: auto; margin-top: 1rem; font-weight: 800">Action Plan Detail</h2>
        <div style="background-color: #f3f4f6; padding: 1rem; display: flex;">
            <div style="width: 20%;font-weight: 800;">Plant: </div><div style="width: 80%;font-weight: 800;">` +
          plantName +
          `</div>
        </div>
        <table style="margin-top: 1.5rem;">
            <tr>
                <th style="background-color:#e7e5e4; padding: 0.8rem">Action Plan</th>
                <th style="background-color:#e7e5e4; padding: 0.8rem">Created Date</th>
                <th style="background-color:#e7e5e4; padding: 0.8rem">Target Date</th>
                <th style="background-color:#e7e5e4; padding: 0.8rem">Responsible</th>
                <th style="background-color:#e7e5e4; padding: 0.8rem">Status</th>
            </tr>
            <tr>
                <td style='text-align: center'>` +
          this.editActionPlanForm.controls.actions.value +
          `</td>
                <td style='text-align: center'>` +
          moment(this.currentNodeDate).format('DD/MM/YYYY hh:mm:ss') +
          `</td>
                <td style='text-align: center'>` +
          moment(date).format('DD/MM/YYYY hh:mm:ss') +
          `</td>
                <td style='text-align: center'>` +
          user.FullName +
          `</td>
                <td style='text-align: center'>Completed</td>
            </tr>
        </table>
    </div>`;
      }
      var emailParam = {
        Body: templateBody,
        ToEmailAddress: this.currentAssigneeEmail,
        CCEmails: this.currentResponsibleEmail,
        Subject: 'Action Completion',
      };
      this.actionplanService.sendMail(emailParam).subscribe(
        (res) => {
          // this.toaster.success("Mail sent", "Success");
        },
        ({ error }) => {
          this.toaster.error('Cannot Send Mail', 'Error');
        }
      );
    }
    if (this.editActionPlanForm.value.verification === 'Approved') {
      this.Status = 'Closed';
      // fiveWhy.ClosedDate = new Date();
    } else if (this.editActionPlanForm.value.verification === 'Disapproved') {
      this.Status = 'ReOpened';
      // fiveWhy.ActionCompleted = 'No';
      this.editActionPlanForm.get('completed').setValue('No');
    }

    const formdata = new FormData();
    formdata.append('file', this.fileSave);
    formdata.append('image', this.ImageSave);
    formdata.append('closefile', this.closefile);
    const key = {
      actionId: this.data.ID,
      actionName: this.editActionPlanForm.value.actions,
      actionType: this.editActionPlanForm.value.actionType,
      responsible: this.editActionPlanForm.value.assignTo,
      targetDate: this.targetDate ? this.targetDate : null,
      revisedDate: this.RevisedDate ? this.RevisedDate : null,
      ActionCompleted: this.editActionPlanForm.value.completed,
      Verification: this.editActionPlanForm.value.verification,
      remarks: this.editActionPlanForm.value.remarks,
      NewAssignee: this.editActionPlanForm.value.NewAssignee
        ? this.editActionPlanForm.value.NewAssignee
        : null,
      status: this.Status,
      userCode: this.paramsValues.participantId,
      // userId: JSON.parse(localStorage.user).UserId,
      rootCause: this.editActionPlanForm.value.rootcause,
      mClassification: this.editActionPlanForm.value?.mClassification
    };
    formdata.append('values', JSON.stringify(key));
    this.actionplanService.editActionPlan(formdata).subscribe((res: any) => {
      if (res[0].Column1 === 'Updated Successfully') {
        this.toaster.success('Success', `Updated Sucessfully `);
        this.getOverallMeetingActions();
        this.currentDialog.close();
        this.showinput = false;
      }
    });
    // }
  }

  getMinDate(type: any): any {
    if (type === 'Revised') {
      const date = this.data.RevisedDate
        ? this.data.RevisedDate
        : this.data.TargetDate;
      const currentDate = new Date(date);

      const minDateStartFrom = new Date(
        currentDate.setDate(currentDate.getDate() + 1)
      );

      return (current: Date): boolean =>
        differenceInCalendarDays(current, minDateStartFrom) < 0;
    } else if (type === 'Target') {
      const currentDate = new Date();
      const minDateStartFrom = new Date(
        currentDate.setDate(currentDate.getDate())
      );

      return (current: Date): boolean =>
        differenceInCalendarDays(current, minDateStartFrom) < 0;
    }
  }

}

